import React from "react";
import ZoneSvgPoint from "./ZoneSvgPoint";
import RoomData from "../../../interfaces/robot/rooms/room-data";
import ZoneControllerMouseState from "../../../enums/robot/zone-planner/zone-controller-mouse-state";
import { useSharedSelector } from "../../../store/SharedProvider";
import { selectSelectedRoomLandmarks } from "../../../store/room/room-selectors";
import { selectHiddenLandmarkIds, selectZonePlannerModeState } from "../../../store/room/zone-planner/zone-planner-selectors";
import ZonePlannerModeState from "../../../enums/robot/zone-planner/zone-planner-mode-state";
import { LandmarkType } from "../../../interfaces/robot/rooms/landmark";
import { getSvgCoordinatesFromRosPoint } from "../../../interfaces/robot/rooms/point";
import ZonePointType from "../../../enums/robot/rooms/zone-point-type";

const Landmarks: React.FC<{
  scale: number;
  roomData: RoomData;
  mouseState: ZoneControllerMouseState;
  scheduleLandmarkSelectionProps?: {
    selectedLandmarkId: string;
    onLandmarkClickOverride: (landmarkId: string) => void;
  };
  isMissionView?: boolean;
}> = ({ scale, mouseState, roomData, scheduleLandmarkSelectionProps, isMissionView }) => {
  const landmarks = useSharedSelector((state) => selectSelectedRoomLandmarks(state));
  const hiddenLandmarkIds = useSharedSelector((state) => selectHiddenLandmarkIds(state));
  const zonePlannerModeState = useSharedSelector((state) => selectZonePlannerModeState(state));

  const showHover =
    mouseState === ZoneControllerMouseState.Default ||
    mouseState === ZoneControllerMouseState.DeleteZone ||
    mouseState === ZoneControllerMouseState.DragZone;

  return (
    <React.Fragment>
      {landmarks
        .filter(
          (lm) =>
            !hiddenLandmarkIds.includes(lm.id) &&
            ((zonePlannerModeState === ZonePlannerModeState.EvacuationMode && lm.type === LandmarkType.Evacuation) ||
              (zonePlannerModeState === ZonePlannerModeState.Default && lm.type === LandmarkType.Maintenance))
        )
        .map((lm) => (
          <ZoneSvgPoint
            key={lm.id}
            point={{
              ...getSvgCoordinatesFromRosPoint(
                { ...lm.landmarkPoint, id: lm.id, type: ZonePointType.LandmarkPoint },
                roomData
              )!,
            }}
            oversize={scheduleLandmarkSelectionProps != null}
            onClickOverride={scheduleLandmarkSelectionProps?.onLandmarkClickOverride}
            oversizeSelectedColor={lm.id === scheduleLandmarkSelectionProps?.selectedLandmarkId ? "orange" : undefined}
            id={lm.id}
            scale={scale}
            type={ZonePointType.LandmarkPoint}
            enlargingOnHoverEnabled={showHover}
            midPointInsertAtIndex={null}
            preventPointerEvents={isMissionView}
          />
        ))}
    </React.Fragment>
  );
};

export default Landmarks;
